import { Loader2 } from "lucide-react";
import { cn } from "@ridereserv/shared/utils";

export interface SpinnerProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

/**
 * Loading spinner component using Lucide icon.
 * Uses semantic color tokens from the design system.
 * @param root0 - Spinner props
 * @param root0.size - Spinner size (sm, md, lg)
 * @param root0.className - Additional CSS classes
 * @returns An animated spinner element
 */
export function Spinner({ size = "md", className }: SpinnerProps) {
  const sizes = {
    sm: "h-4 w-4",
    md: "h-6 w-6",
    lg: "h-8 w-8",
  };

  return (
    <Loader2
      className={cn("animate-spin text-primary-600", sizes[size], className)}
      aria-label="Loading"
    />
  );
}
